require('./snowfall');
require('./ya_garland');

function letItSnow() {
	let $wrapper = $('[data-theme="ny"]');
	$wrapper.find('.snow-1').css('height', $wrapper.height());
	$wrapper.find('.snow-2').css('height', $wrapper.height());
	$wrapper.find('.snow-3').css('height', $wrapper.height());

	$('.snow-1').snowfall({
		flakeCount: isMobile() ? 7 : 50,
		minSize: 3,
		round: true,
		flakeIndex: 10,
		maxSize: 13,
		minSpeed: isMobile() ? 0.5 : 1,
		maxSpeed: isMobile() ? 1 : 2,
		image: '/assets/_frontend/images/theme/ny/snow-1.png'
	});

	$('.snow-2').snowfall({
		flakeCount: isMobile() ? 7 : 70,
		minSize: 5,
		round: true,
		flakeIndex: 10,
		maxSize: 15,
		minSpeed: isMobile() ? 0.5 : 1,
		maxSpeed: isMobile() ? 1 : 3,
		image: '/assets/_frontend/images/theme/ny/snow-2.png'
	});

	$('.snow-3').snowfall({
		flakeCount: isMobile() ? 7 : 100,
		minSize: 2,
		round: true,
		flakeIndex: 10,
		maxSize: 10,
		minSpeed: isMobile() ? 0.5 : 1,
		maxSpeed: isMobile() ? 1 : 1,
		image: '/assets/_frontend/images/theme/ny/snow-3.png'
	});
}

document.addEventListener('DOMContentLoaded', function () {
	letItSnow();
})
